
  import { defineComponent, onMounted, reactive, ref, onActivated, watch, toRefs, nextTick } from 'vue'
  import _ from 'lodash'
  import router from '@/router'
  import { carsApplyList, getOpenId } from '@/apis/comm/api'
  import { GetQueryString, ToWechat } from '@/utils/index'
  import { useToken, useInfoUser } from '@/hooks/storage'

  export default defineComponent({
    name: 'Public',
    setup() {
      onMounted(() => {
        nextTick(() => {
          var u = navigator.userAgent
          var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
          if (isiOS) {
            window.onpageshow = function (event) {
              if (event.persisted) {
                window.location.reload()
              }
            }
          }
        })
        info.code = GetQueryString('code')
        if (info.code) {
          info.getUserID()
        } else {
          let openId = window.sessionStorage.getItem('openId')
          if (openId) {
            info.openId = openId
            info.getList()
          } else if (useToken().get()) {
            let user = JSON.parse(useInfoUser().get())
            info.openId = user.gh
            info.getList()
          } else {
            ToWechat('pub/index')
          }
        }
      })

      const info = reactive({
        code: '' as any,
        active: 0,
        tabName: [{ name: '访问记录' }] as any,
        list: [],
        openId: '',
        times: '',
        onClickTab(name: any) {
          info.getList()
        },
        goto() {
          router.replace({
            path: '/pub/apply'
          })
        },
        goHome() {
          router.replace({
            path: '/'
          })
        },
        getUserID: async () => {
          const res = await getOpenId(info.code)
          info.openId = res.data.data.openid
          window.sessionStorage.setItem('openId', info.openId)
          info.getList()
        },
        // 10 审批通过 5审批中  15拒绝
        getList: async () => {
          if (!info.openId) return ToWechat('pub/index')
          const res = await carsApplyList({
            openId: info.openId,
            applyType: 1
          })
          if (res.data.code == 200) {
            info.getDate()
            info.list = res.data.data

            let b: any = new Date(info.times)
            info.list.forEach((el: any) => {
              let a = new Date(el.visiEndTime)
              if (a < b) {
                el['Isexpired'] = true
              } else {
                el['Isexpired'] = false
              }
            })
          }
        },
        godetail(item) {
          router.push('/pub/detail?id=' + item.id)
        },
        getDate() {
          var today = new Date()
          var year = today.getFullYear() // 年
          var month = today.getMonth() + 1 // 月（注意需要加1）
          var day = today.getDate() // 日
          month > 10 ? month : '0' + month
          day > 10 ? day : '0' + day
          info.times = year + '-' + month + '-' + day
        }
      })

      return toRefs(info)
    }
  })
